export function getColor(colorName: string) {
	return getComputedStyle(document.documentElement).getPropertyValue(`--${colorName}`).trim();
}
